import { ChevronLeft, ChevronRight, Presentation } from 'lucide-react'
import { Button } from '@/components/ui/Button'

type ProposalPresentationPagerProps = {
  index: number
  total: number
  onPrev: () => void
  onNext: () => void
  onPresent: () => void
}

export function ProposalPresentationPager({
  index,
  total,
  onPrev,
  onNext,
  onPresent,
}: ProposalPresentationPagerProps) {
  const label = `${String(index + 1).padStart(2, '0')} / ${String(total).padStart(2, '0')}`
  return (
    <>
      <div className="flex items-center justify-center gap-3 py-5">
        <button
          type="button"
          aria-label="Slide anterior"
          onClick={onPrev}
          className="flex h-10 w-10 items-center justify-center rounded-full bg-white text-[#1c1c1c] shadow-md"
        >
          <ChevronLeft size={18} />
        </button>
        <span className="min-w-[84px] text-center text-sm font-semibold tabular-nums text-[#3a3a3a]">
          {label}
        </span>
        <button
          type="button"
          aria-label="Próximo slide"
          onClick={onNext}
          className="flex h-10 w-10 items-center justify-center rounded-full bg-white text-[#1c1c1c] shadow-md"
        >
          <ChevronRight size={18} />
        </button>
      </div>
      <div className="fixed bottom-6 right-6">
        <Button type="button" icon={<Presentation size={16} />} onClick={onPresent}>
          Apresentar
        </Button>
      </div>
    </>
  )
}
